import type * as React from 'react';
import {
  SvgAccount,
  SvgAccountFull,
  SvgAI,
  SvgAlertCircle,
  SvgAmericanFootball,
  SvgAnalysis,
  SvgArrowBack,
  SvgArrowBackCircle,
  SvgArrowDown,
  SvgArrowDownCircle,
  SvgArrowForward,
  SvgArrowForwardCircle,
  SvgArrowUp,
  SvgArrowUpCircle,
  SvgAthletics,
  SvgAussieRules,
  SvgAZ,
  SvgBadminton,
  SvgBaseball,
  SvgBasketball,
  SvgBetslip,
  SvgBettingSites,
  SvgBettingSplits,
  SvgBowls,
  SvgBoxing,
  SvgBurgerMenu,
  SvgCasino,
  SvgCombatSports,
  SvgCricket,
  SvgCrypto,
  SvgCup,
  SvgCycling,
  SvgDarts,
  SvgDiscord,
  SvgEducation,
  SvgESports,
  SvgEyes,
  SvgEyesOff,
  SvgFilter,
  SvgFilterSliders,
  SvgFinance,
  SvgGolf,
  SvgGreyhounds,
  SvgHandball,
  SvgHitRate,
  SvgHome,
  SvgHorseRacing,
  SvgIceHockey,
  SvgInfoCircle,
  SvgInsights,
  SvgLacrosse,
  SvgLogOut,
  SvgMatchups,
  SvgMotorsport,
  SvgNewWindow,
  SvgNoWifi,
  SvgOffersFull,
  SvgOffersOutline,
  SvgPadlock,
  SvgPolitics,
  SvgPool,
  SvgPopular,
  SvgPositiveEV,
  SvgPremiumTipsUS,
  SvgRowing,
  SvgRugby,
  SvgSearch,
  SvgSnooker,
  SvgSoccer,
  SvgSort,
  SvgSquash,
  SvgStarFull,
  SvgStarOutline,
  SvgTableTennis,
  SvgTennis,
  SvgTickCircle,
  SvgTipsFire,
  SvgTools,
  SvgTrash,
  SvgTrends,
  SvgTV,
  SvgVolleyball,
  SvgWinterSports,
  SvgXCross,
} from '@fpsm/cxy-icons/glyphs/uk';

/**
 * The UK icon set, keyed by its Figma name.
 *
 * An explicit object literal rather than a re-export barrel like `icons/index.ts`, because two
 * Figma names — `A-Z` and `E-Sports` — are not valid JavaScript identifiers and cannot be
 * `export { default as … }`ed. The keys are the CMS-facing contract, so they stay byte-identical
 * to Figma; the component names beside them are only local.
 */
export const ukIcons: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  'A-Z': SvgAZ,
  AI: SvgAI,
  Account: SvgAccount,
  Account_Full: SvgAccountFull,
  Alert_Circle: SvgAlertCircle,
  American_Football: SvgAmericanFootball,
  Analysis: SvgAnalysis,
  Arrow_Back: SvgArrowBack,
  Arrow_Back_Circle: SvgArrowBackCircle,
  Arrow_Down: SvgArrowDown,
  Arrow_Down_Circle: SvgArrowDownCircle,
  Arrow_Forward: SvgArrowForward,
  Arrow_Forward_Circle: SvgArrowForwardCircle,
  Arrow_Up: SvgArrowUp,
  Arrow_Up_Circle: SvgArrowUpCircle,
  Athletics: SvgAthletics,
  Aussie_Rules: SvgAussieRules,
  Badminton: SvgBadminton,
  Baseball: SvgBaseball,
  Basketball: SvgBasketball,
  Betslip: SvgBetslip,
  Betting_Sites: SvgBettingSites,
  Betting_Splits: SvgBettingSplits,
  Bowls: SvgBowls,
  Boxing: SvgBoxing,
  Burger_Menu: SvgBurgerMenu,
  Casino: SvgCasino,
  Combat_Sports: SvgCombatSports,
  Cricket: SvgCricket,
  Crypto: SvgCrypto,
  Cup: SvgCup,
  Cycling: SvgCycling,
  Darts: SvgDarts,
  Discord: SvgDiscord,
  'E-Sports': SvgESports,
  Education: SvgEducation,
  Eyes: SvgEyes,
  Eyes_Off: SvgEyesOff,
  Filter: SvgFilter,
  Filter_Sliders: SvgFilterSliders,
  Finance: SvgFinance,
  Golf: SvgGolf,
  Greyhounds: SvgGreyhounds,
  Handball: SvgHandball,
  Hit_Rate: SvgHitRate,
  Home: SvgHome,
  Horse_Racing: SvgHorseRacing,
  Ice_Hockey: SvgIceHockey,
  Info_Circle: SvgInfoCircle,
  Insights: SvgInsights,
  Lacrosse: SvgLacrosse,
  Log_Out: SvgLogOut,
  Matchups: SvgMatchups,
  Motorsport: SvgMotorsport,
  New_Window: SvgNewWindow,
  No_Wifi: SvgNoWifi,
  Offers_Full: SvgOffersFull,
  Offers_Outline: SvgOffersOutline,
  Padlock: SvgPadlock,
  Politics: SvgPolitics,
  Pool: SvgPool,
  Popular: SvgPopular,
  Positive_EV: SvgPositiveEV,
  Premium_Tips_US: SvgPremiumTipsUS,
  Rowing: SvgRowing,
  Rugby: SvgRugby,
  Search: SvgSearch,
  Snooker: SvgSnooker,
  Soccer: SvgSoccer,
  Sort: SvgSort,
  Squash: SvgSquash,
  Star_Full: SvgStarFull,
  Star_Outline: SvgStarOutline,
  TV: SvgTV,
  Table_Tennis: SvgTableTennis,
  Tennis: SvgTennis,
  Tick_Circle: SvgTickCircle,
  Tips_Fire: SvgTipsFire,
  Tools: SvgTools,
  Trash: SvgTrash,
  Trends: SvgTrends,
  Volleyball: SvgVolleyball,
  Winter_Sports: SvgWinterSports,
  X_Cross: SvgXCross,
};
